var option = {
  title: {
    text: "",
    subtext: "",
    sublink: "",
    left: "center"
  },
  tooltip: {
    trigger: "item",
    formatter: function(params, ticket, callback) {
      // params.name.split(':')[0]+ '</br>' + params.name.split(':')[1] + '</br>' + params.value[2]
      return (
        params.name.split(":")[0] +
        "</br>" +
        params.name.split(":")[1] +
        "</br>" +
        params.value[2]
      );
    }
  },
  visualMap: {
    // 视觉映射组件
    type: "continuous",
    min: 0,
    max: 200,
    calculable: true,
    inRange: {
      color: ["#50a3ba", "#eac736", "#d94e5d"]
    },
    textStyle: {
      color: "#fff"
    }
  },
  bmap: {
    center: [117.031825, 36.681449],
    zoom: 8,
    roam: true,
    mapStyle: {
      styleJson: [
        {
          featureType: "water",
          elementType: "all",
          stylers: {
            color: "#d1d1d1"
          }
        },
        {
          featureType: "land",
          elementType: "all",
          stylers: {
            color: "#f3f3f3"
          }
        },
        {
          featureType: "railway",
          elementType: "all",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "highway",
          elementType: "all",
          stylers: {
            color: "#fdfdfd"
          }
        },
        {
          featureType: "highway",
          elementType: "labels",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "arterial",
          elementType: "geometry",
          stylers: {
            color: "#fefefe"
          }
        },
        {
          featureType: "arterial",
          elementType: "geometry.fill",
          stylers: {
            color: "#fefefe"
          }
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "green",
          elementType: "all",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "subway",
          elementType: "all",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "manmade",
          elementType: "all",
          stylers: {
            color: "#d1d1d1"
          }
        },
        {
          featureType: "local",
          elementType: "all",
          stylers: {
            color: "#d1d1d1"
          }
        },
        {
          featureType: "arterial",
          elementType: "labels",
          stylers: {
            visibility: "off"
          }
        },
        {
          featureType: "boundary",
          elementType: "all",
          stylers: {
            color: "#fefefe"
          }
        },
        {
          featureType: "building",
          elementType: "all",
          stylers: {
            color: "#d1d1d1"
          }
        },
        {
          featureType: "label",
          elementType: "labels.text.fill",
          stylers: {
            color: "#999999"
          }
        }
      ]
    }
  },
  series: [
    {
      name: "pm2.5",
      type: "scatter",
      coordinateSystem: "bmap",
      data: []
    }
  ]
};

var option_alarm = {
  chart: {},
  title: {
    text: ""
  },
  annotations: [
    {
      labels: []
    }
  ],
  subtitle: {
    text: ""
  },
  credits: {
    enabled: false // 禁用版权信息
  },
  xAxis: {
    type: "datetime",
    dateTimeLabelFormats: {
      millisecond: "%H:%M:%S.%L",
      second: "%H:%M:%S",
      minute: "%H:%M",
      hour: "%H:%M",
      day: "%m-%d",
      week: "%m-%d",
      month: "%Y-%m",
      year: "%Y"
    },
    plotLines: []
  },
  yAxis: {
    title: {
      text: ""
    },
    min: 0
  },
  tooltip: {
    shared: true,
    crosshairs: true,
    dateTimeLabelFormats: {
      second: "%Y-%m-%d %H:%M:%S",
      minute: "%Y-%m-%d %H:%M:%S",
      hour: "%Y-%m-%d %H:%M:%S",
      day: "%Y-%m-%d %H:%M:%S",
      week: "%Y-%m-%d %H:%M:%S",
      month: "%Y-%m-%d %H:%M:%S",
      year: "%Y-%m-%d %H:%M:%S"
    }
  },
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "middle"
  },
  series: [
    {
      name: "安装，实施人员",
      data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
    },
    {
      name: "工人",
      data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
    },
    {
      name: "销售",
      data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
    },
    {
      name: "项目开发",
      data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
    },
    {
      name: "其他",
      data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
    }
  ],
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom"
          }
        }
      }
    ]
  }
};

const option_time = [
  {
    value: "min",
    label: "实时"
  },
  {
    value: "hour",
    label: "时均"
  },
  {
    value: "day",
    label: "日均"
  },
  {
    value: "week",
    label: "周均"
  },
  {
    value: "month",
    label: "月均"
  },
  // {
  //   value: "year",
  //   label: "年均"
  // },
];

const option_data_type = [
  {
    value: "pm10",
    label: "PM₁₀",
    unit: "μg/m³"
  },
  {
    value: "pm25",
    label: "PM₂.₅",
    unit: "μg/m³"
  },
  {
    value: "shidu",
    label: "湿度",
    unit: "RH%"
  },
  {
    value: "wendu",
    label: "温度",
    unit: "℃"
  },
  {
    value: "wind_direction",
    label: "风向",
    unit: "deg"
  },
  {
    value: "wind_speed",
    label: "风速",
    unit: "m/s"
  },
  {
    value: "so2_f",
    label: "SO₂",
    unit: "μg/m³"
  },
  // {
  //   value: "co",
  //   label: "CO",
  //   unit: "μg/m³"
  // },
  {
    value: "no2",
    label: "NO₂",
    unit: "μg/m³"
  },
  {
    value: "o3",
    label: "O₃",
    unit: "μg/m³"
  },
  {
    value: "tvoc",
    label: "TVOC",
    unit: "μg/m³"
  }
];

const option_region = [
  { label: "全市", value: 727 },
  { label: "商河县", value: 736 },
  { label: "章丘", value: 737 },
  { label: "高新区", value: 738 },
  { label: "南部山区", value: 739 },
  { label: "历下区", value: 728 },
  { label: "市中区", value: 729 },
  { label: "槐荫区", value: 730 },
  { label: "天桥区", value: 731 },
  { label: "历城区", value: 732 },
  { label: "长清区", value: 733 },
  { label: "平阴县", value: 734 },
  { label: "济阳县", value: 735 }
];

var pm10RangeColor = [];
var pm25RangeColor = [];
for (var i of G_SENSOR_DATA_TYPE_INFO) {
  // if (i.bgcolor == '#000000'){
  //   i.bgcolor = 'rgb(115, 115, 115)'
  // }
  pm25RangeColor.push({
    start: i.color_range_min,
    end: i.color_range_max + 1,
    value: i.bgcolor
  });
  pm10RangeColor.push({
    start: i.color_range_min,
    end: i.color_range_max + 1,
    value: i.bgcolor
  });
}
// pm25RangeColor.push({"lowval_pm25":-10,"highval_pm25":1,"lowval_pm10":-10,"highval_pm10":1,"description":"掉线","bgcolor":"red","fgcolor":"#ffffff","type":"valid"})
pm25RangeColor.push({ start: -10, end: 0, value: "#8a8a8a" });
pm10RangeColor.push({ start: -10, end: 0, value: "#8a8a8a" });
var range_color = {
  pm25: pm25RangeColor,
  pm10: pm10RangeColor
};

let waterTypes = [
  {
    label: "COD",
    unit: "mg/L",
    value: "cod",
    limit: 40
  },
  {
    label: "氨氮",
    unit: "mg/L",
    value: "ammonia_nitrogen",
    limit: 2
  },
  {
    label: "浊度",
    unit: "NTU",
    value: "turbidity",
    limit: null
  },
  {
    label: "水温",
    unit: "°C",
    value: "temperature",
    limit: null
  },
  // {
  //   label: "电导率",
  //   unit: "us/cm",
  //   value: "conductivity"
  // },
  // {
  //   label: "溶解氧",
  //   unit: "mg/L",
  //   value: "dissolved_oxygen"
  // },
  {
    label: "PH",
    unit: "",
    value: "ph",
    limit: "6~9"
  }
];

if (location.host === "jnwater.novaecs.com") {
  waterTypes = [
    {
      label: "COD",
      unit: "mg/L",
      value: "cod",
      limit: 40
    },
    {
      label: "浊度",
      unit: "NTU",
      value: "turbidity",
      limit: null
    },
    {
      label: "水温",
      unit: "°C",
      value: "temperature",
      limit: null
    },
    {
      label: "电导率",
      unit: "us/cm",
      value: "conductivity"
    },

  ];
}

const waterStandards = [
  {level: '3', name:"Ⅲ类", cod: "20mg/L", ammonia_nitrogen: '1mg/L', phosphorus: '0.2mg/L', ph: '6~9'},
  {level: '4', name:"Ⅳ类", cod: "30mg/L", ammonia_nitrogen: '1.5mg/L', phosphorus: '0.3mg/L', ph: '6~9'},
  {level: '5', name:"Ⅴ类", cod: "40mg/L", ammonia_nitrogen: '2mg/L', phosphorus: '0.4mg/L', ph: '6~9'}
]

const station_level_options = ["国标站","省标站","市标站","县标站"]

export {
  option,
  option_alarm,
  option_time,
  option_data_type,
  option_region,
  range_color,
  waterTypes,
  waterStandards,
  station_level_options
};



// WEBPACK FOOTER //
// ./src/option/option.js